export interface ISede {
  claveSede?: string | null;
  descripcionSede?: string | null;
  nombreDependencia?: string | null;
}

export class Sede implements ISede {
  constructor(public claveSede?: string | null, public descripcionSede?: string | null, public nombreDependencia?: string | null) {}

  static fromObject(data: ISede): Sede {
    const sede = new Sede();
    for (const [key, value] of Object.entries(data)) {
      sede[key] = value;
    }
    return sede;
  }
}
